import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
import { store } from "store";
import { findDocument } from "utils";
import { scanner } from "sensor";
var DeviceStartView = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceStartView, _super);
    function DeviceStartView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.statusMessage = null;
        _this.newName = "";
        return _this;
    }
    Object.defineProperty(DeviceStartView.prototype, "bluetoothSupported", {
        get: function () {
            return scanner.supported;
        },
        enumerable: true,
        configurable: true
    });
    DeviceStartView.prototype.ReplyRequest = function (email, responseResult) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, sindex, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.post("user/requestresponse", {
                                serialNumber: this.device.serial,
                                email: email,
                                response: responseResult
                            })];
                    case 1:
                        result = (_b.sent()).data;
                        if (result) {
                            sindex = this.device.deviceRequest.findIndex(function (x) { return x.email === email; });
                            this.device.deviceRequest.splice(sindex, 1);
                            if (this.device.deviceRequest.length == 0)
                                this.device.deviceRequest = null;
                        }
                        else {
                            this.statusMessage = "Error";
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        this.statusMessage = "Error";
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DeviceStartView.prototype.routed = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var notReadDoc;
            return tslib_1.__generator(this, function (_a) {
                if (this.device.deviceRequest && this.device.deviceRequest.length == 0)
                    this.device.deviceRequest = null;
                notReadDoc = findDocument(this.product, function (d) { return d.mustRead && store.documentsRead.indexOf(d.documentId) == -1; });
                if (notReadDoc) {
                    this.$router.replace({
                        name: "DeviceDocument",
                        params: { serial: this.device.serial, documentId: notReadDoc.documentId }
                    });
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], DeviceStartView.prototype, "device", void 0);
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], DeviceStartView.prototype, "product", void 0);
    DeviceStartView = tslib_1.__decorate([
        Component
    ], DeviceStartView);
    return DeviceStartView;
}(Vue));
export default DeviceStartView;
